import React, { useEffect } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import {
    FormUploadFile,
    Form,
    CustomFile as BaseCustomFile,
} from '../../../../base/base-forms';
import { UploadFileTypes } from '../../../../common/consts/generic.consts';
import { StyledFileUploadContainer } from './FileUploadAction.styles';
import {
    IActionCustomFile,
    UnifiedAnswerType,
} from '../AnswerActionComponents.interfaces';

interface FileUploadFormValues {
    answer?: BaseCustomFile;
}

interface FileUploadActionProps {
    onSelectionChange: (value: UnifiedAnswerType) => void;
}

const FileUploadAction: React.FC<FileUploadActionProps> = ({
    onSelectionChange,
}) => {
    const validationSchema = Yup.object().shape({
        answer: Yup.mixed<BaseCustomFile>().test(
            'required',
            'File is required',
            (value) => value !== undefined && value !== null
        ),
    });

    const methods = useForm<FileUploadFormValues>({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            answer: undefined,
        },
    });

    const { watch } = methods;

    const fileValue = watch('answer');

    useEffect(() => {
        validationSchema
            .validateAt('answer', { answer: fileValue })
            .then(() =>
                onSelectionChange(fileValue as IActionCustomFile | undefined)
            )
            .catch(() => onSelectionChange(undefined));
    }, [fileValue, onSelectionChange, validationSchema]);

    const onSubmit: SubmitHandler<FileUploadFormValues> = (data) => {
        if (data.answer) {
            onSelectionChange(data.answer as IActionCustomFile);
        } else {
            onSelectionChange(undefined);
        }
    };

    return (
        <Form
            methods={methods}
            onSubmit={onSubmit}
            style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
            <StyledFileUploadContainer>
                <FormUploadFile
                    name="answer"
                    type={UploadFileTypes.file}
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        '& > .MuiBox-root': {
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            '& > div[class*="StyledDropZone"]': {
                                flexGrow: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            },
                        },
                    }}
                />
            </StyledFileUploadContainer>
        </Form>
    );
};

export default FileUploadAction;
